<template>
    <div class="mapouter">
        <div class="gmap_canvas">
            <iframe v-if="urlMapa" class="gmap_iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                allowfullscreen referrerpolicy="no-referrer-when-downgrade" :src="urlMapa">
            </iframe>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, watch } from 'vue';
    import { useRoute } from 'vue-router';

    const route = useRoute();
    const urlMapa = ref('');

    async function carregarMapa(id) {
        urlMapa.value = '';
        if (!id) return;

        try {
            const r = await fetch(`https://peconnect.com.br/api/equipamento/${id}`);
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            const j = await r.json();
            urlMapa.value = j.urlMapa;
        } catch (e) {
            console.error('Erro ao buscar mapa:', e);
        }
    }

    onMounted(() => carregarMapa(Number(route.params.id)));
    watch(() => route.params.id, id => carregarMapa(Number(id)));
</script>

<style scoped>
.mapouter {
    position: relative;
    text-align: right;
    width: 171px;
    height: 142px;
}

.gmap_canvas {
    overflow: hidden;
    background: none !important;
    width: 171px;
    height: 142px;
}

.gmap_iframe {
    width: 171px;
    height: 142px;
}
</style>